import { render, staticRenderFns } from "./Glossary.vue?vue&type=template&id=7336a3c2&"
import script from "./Glossary.vue?vue&type=script&lang=js&"
export * from "./Glossary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eric/projects/musical/musical-admin-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7336a3c2')) {
      api.createRecord('7336a3c2', component.options)
    } else {
      api.reload('7336a3c2', component.options)
    }
    module.hot.accept("./Glossary.vue?vue&type=template&id=7336a3c2&", function () {
      api.rerender('7336a3c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Glossary.vue"
export default component.exports